'use client'

import { useEffect, useState } from 'react'
import clsx from 'clsx'
import dynamic from 'next/dynamic'
import { useSession } from 'next-auth/react'

import NavigationMobile from 'composition/navigation/NavigationMobile'
import NavigationWeb from 'composition/navigation/NavigationWeb'
import { AuthNavigation as AuthNavigationWeb } from 'modules/auth'
import { GuestCartInitializer } from 'modules/cart'
import { useRibbon } from 'modules/content'
import {
  extractCustomerFromClientSession,
  OnboardCustomerForm
} from 'modules/customer'
import {
  FetchUpsellingResponse,
  NavMenuCategory,
  ProductTypes
} from 'modules/products'
import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'
import { noop } from 'shared/utils/common'
import { isNilOrEmpty, isNotNilOrEmpty } from 'shared/utils/ramda'

import MobileSubmenu from './MobileSubmenu'

import styles from './Navigation.module.scss'

const Ribbon = dynamic(
  () => import('modules/content').then(mod => mod.Ribbon),
  {
    ssr: false
  }
)

const Navigation = ({
  isMinimalistHeader,
  promotedProducts,
  categories,
  menuPromotionItems
}: {
  isMinimalistHeader?: boolean
  promotedProducts: ProductTypes[]
  categories: NavMenuCategory[]
  menuPromotionItems: FetchUpsellingResponse['data'] | null
}) => {
  const session = useSession()

  const user = extractCustomerFromClientSession(session)
  const [updateUserDetailsModalOpen, setUpdateUserDetailsModalOpen] =
    useState(false)

  const { ribbon } = useRibbon()

  useEffect(() => {
    if (isNotNilOrEmpty(user) && isNilOrEmpty(user?.lastName)) {
      setUpdateUserDetailsModalOpen(true)
    } else if (updateUserDetailsModalOpen) {
      setUpdateUserDetailsModalOpen(false)
    }
  }, [user])

  return (
    <header>
      <Ribbon />
      <div
        className={clsx(styles.navigationWrapper, {
          [styles.ribbonOpen]: !!ribbon,
          [styles.minimalistic]: isMinimalistHeader
        })}
      >
        <div className={styles.webContent}>
          <NavigationWeb
            promotedProducts={promotedProducts || []}
            categories={categories}
            menuPromotionItems={menuPromotionItems}
          />
        </div>
        <div className={styles.tabletContent}>
          {isMinimalistHeader ? (
            <AuthNavigationWeb className='minimalistic-mobile-nav' />
          ) : (
            <NavigationMobile
              promotedProducts={promotedProducts || []}
              categories={categories}
              menuPromotionItems={menuPromotionItems}
            />
          )}
        </div>
      </div>
      {!isMinimalistHeader && <MobileSubmenu isRibbonOpen={!!ribbon} />}
      <Modal
        id='update-user-data-modal'
        open={updateUserDetailsModalOpen}
        onClose={noop}
        hideDefaultCloseButton
        closeOnBackdropClick={false}
        closeOnEscape={false}
      >
        <ModalTitle>Zaktualizuj dane</ModalTitle>
        <ModalDescription visuallyHidden>
          Prosimy o uzupełnienie brakujących danych, aby kontynuować zakupy.
        </ModalDescription>
        <OnboardCustomerForm />
      </Modal>
      <GuestCartInitializer />
    </header>
  )
}

export default Navigation
